import { getItemAttributeValueByIdentifier } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/AttributeSelectors';
import { AttributeIdentifiers } from '../Enums';
import { formatHexColor } from './editorUnits';
import type { EditorItem, TextItem } from '../Reducers/Configurator/types';

export function resolveTextColorOptionId(item: TextItem, options: unknown[]): string | null {
  if (item.colorOptionId) return item.colorOptionId;
  const itemHex = formatHexColor(item.color);
  return (
    (
      options.find(
        (opt) =>
          formatHexColor(getItemAttributeValueByIdentifier(opt, AttributeIdentifiers.hex, '000000')) ===
          itemHex
      ) as { identifier?: string } | undefined
    )?.identifier ?? null
  );
}

export function resolveTextColorOptionIdFromHex(
  hex: string,
  colorOptionId: string | undefined,
  hexToOptionId: Record<string, string>
): string | null {
  return colorOptionId ?? hexToOptionId[formatHexColor(hex)] ?? null;
}

export function resolveItemColorOptionIds(item: EditorItem, options: unknown[]): string[] {
  if (item.type === 'text') {
    const colorId = resolveTextColorOptionId(item, options);
    return colorId ? [colorId] : [];
  }

  return item.colorAreas?.map((area) => area.colorOptionId).filter(Boolean) || [];
}
